import { createSelector } from '@reduxjs/toolkit';
import {
    ACCA_BOOST_TYPE_ID,
} from '~shared/utils/constants';

const selectBonuses = ({ bonuses }) => bonuses;

export const selectAccaBoostBonusDetails = createSelector(
    selectBonuses,
    (bonuses = {}) => bonuses?.find((bonus) => bonus?.type_id === ACCA_BOOST_TYPE_ID) || {}
);

export const selectAccaBoostMinLegs = createSelector(
    selectAccaBoostBonusDetails,
    ({ restrictions }) => restrictions?.min_legs
);

export const selectAccaBoostMinOddsPerLeg = createSelector(
    selectAccaBoostBonusDetails,
    ({ restrictions }) => restrictions?.min_odds_per_leg || {}
);

export const selectAccaBoostMarkets = createSelector(
    selectAccaBoostBonusDetails,
    ({ restrictions }) => restrictions?.eligible_market_ids || []
);

export const selectAccaBoostLadder = createSelector(
    selectAccaBoostBonusDetails,
    ({ info }) => info?.boost || {}
);
